<template>
  <section class="desktop-footer">
    <a target="_blank" href="http://changba.com/en/index.html">English</a>|
    <a target="_blank" href="https://changba.com/account/official_check.php">重新设置密码</a>|
    <a target="_blank" href="http://changba.com/now/help/helpcenter.php?typeid=1">帮助中心</a>|
    <a target="_blank" href="http://changba.com/now/contact.php">联系我们</a>|
    <a target="_blank" href="http://changba.com/now/joinus.php?ver=1.0.1">加入唱吧</a>|
    <a target="_blank" href="http://about.58.com/fqz/index.html?utm_source=market&amp;spm=b-31580022738699-pe-f-829.hao360_101" rel="external nofollow noopener">防诈骗专栏</a>|
    <a href="http://xwm.qs12315.com" target="_blank" rel="external nofollow noopener">商品防伪查询</a>
    <br>
    北京酷智科技有限公司 ©2024 changba.com | <a target="_blank" href="//comp.cdn.changbaimg.com/images/officialwebsite/icp.png?ver=1.0.1" rel="external nofollow">京ICP证110298</a> | 举报电话(24小时)：028-85402786 | 举报邮箱：fankui@changba.com<a target="_blank" href="https://jbts.mct.gov.cn/" rel="external nofollow noopener"> | 向12318举报</a><br>
    <a target="_blank" href="//comp.cdn.changbaimg.com/images/officialwebsite/icp2019.pdf" rel="external nofollow">京网文[2018]5625-430号</a> | <a href="https://res.cdn.changbaimg.com/-/6f1eecb9e6a463d9/busines_performance_license.pdf">营业性演出许可证</a> |
    <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502025063" rel="external nofollow noopener"><img style="vertical-align: top;" src="//cb.cdn.changbaimg.com/images/officialwebsite/ghs.png">京公网安备11010502025063号</a>
    |
    <a id="___szfw_logo___" href="https://credit.szfw.org/CX20170719035153320357.html" target="_blank" rel="noopener"><img src="//cb.cdn.changbaimg.com/images/officialwebsite/sf.png" border="0" style="height: 18px;vertical-align: top;"></a>
  </section>
</template>

<script>
export default {
  name: 'DesktopFooter'
};
</script>

<style lang="scss" no-px2rem>
.desktop-footer {
  width: 980px;
  margin: 50px auto;
  color: #b2b2b2;
  font-size: 14px;
  line-height: 18px;
  text-align: center;

  a {
    color: #8b8a8a;
    text-decoration: none;
  }
}
</style>
